import { useContext, useRef } from 'react'

import { Pagination } from '@procurify/ui'
import { nanoid } from 'nanoid'

import { usePagination } from '@webapp/core/hooks/usePagination'
import { type PaginationID } from '@webapp/core/providers/Pagination/pagination.types'
import { PaginationControlsContext } from '@webapp/core/providers/Pagination/PaginationControlsContext'

export interface IPaginationPageProps {
  id?: PaginationID
}

export const PaginationPage = ({ id: idOverride }: IPaginationPageProps) => {
  const { id } = useContext(PaginationControlsContext)

  const paginationId = idOverride || id

  if (!paginationId) {
    throw new Error(
      'PaginationPage must be used within a PaginationControls context or provide an id prop'
    )
  }

  const { state, params, updatePage } = usePagination({ id: paginationId })
  const inputIdRef = useRef(`${paginationId}-page-${nanoid(10)}`)

  const onPageChange = (page: number) => {
    updatePage(page)
  }

  return (
    <Pagination
      inputId={inputIdRef.current}
      currentPage={params.page}
      numPages={state.numPages}
      onPageChange={onPageChange}
    />
  )
}
